import { render } from "./SliderItems.vue?vue&type=template&id=00bde260"
import script from "./SliderItems.vue?vue&type=script&lang=js"
export * from "./SliderItems.vue?vue&type=script&lang=js"

import "./SliderItems.vue?vue&type=style&index=0&id=00bde260&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__